import Reveal from "./Reveal";
import { SITE } from "../config/siteConfig";

export default function Galerie() {
  const g25 = SITE.gallery.y2025;
  const g26 = SITE.gallery.y2026;

  return (
    <section id="galerie" className="py-16 md:py-28" data-testid="section-galerie">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <p className="eyebrow text-brand-dark">
            <span className="eyebrow-rule" aria-hidden="true" />
            Galerie
          </p>
          <h2 className="h2 mt-4">Galerien</h2>
        </Reveal>

        <Reveal>
          <div className="mt-12" data-testid="gallery-2025">
            <div className="flex items-center gap-4">
              <h3 className="font-display text-2xl md:text-3xl">{g25.title}</h3>
              <span className="h-[3px] flex-1 bg-line" aria-hidden="true" />
            </div>
            <p className="mt-3 text-base text-ink/80">{g25.text}</p>
            <div className="mt-6 grid gap-3 sm:grid-cols-2 sm:gap-4">
              {g25.images.map((img, i) => (
                <figure
                  key={img.src}
                  data-testid={`gallery-2025-image-${i + 1}`}
                  className="card-tile overflow-hidden"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    loading="lazy"
                    className="aspect-video w-full object-cover"
                  />
                </figure>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div
            data-testid="gallery-2026"
            className="relative mt-12 overflow-hidden rounded-md border border-dashed border-line p-8 text-center md:p-14"
          >
            <span
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 flex select-none items-center justify-center font-display text-[clamp(4rem,14vw,9rem)] leading-none text-brand-red/10"
            >
              2026
            </span>
            <h3 className="relative font-display text-2xl md:text-3xl">{g26.title}</h3>
            <p className="relative mx-auto mt-3 max-w-[46ch] text-base text-ink/80">
              {g26.emptyText}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
